export default "__VITE_ASSET__D7tT9PFl__"